/**
 * This file exposes frequently used checking methods.
 *
 * These methods are auto-imported in components and pages and can be used
 * directly in templates, <script setup> or anywhere in the Options API without
 * having to manually import them.
 */

/**
 * Check if a value is not null or undefined.
 *
 * @param value The value to check.
 * @returns True if the value is not null or undefined, false otherwise.
 *
 * @example hasValue(10) // true
 */
export function hasValue(value?: unknown) {
  return value !== null && value !== undefined
}
